<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <img :src="`${assetPath}lockup-overlays/quiz_03-overlay--left@2x.png`" alt="">
    </div>
    <div class="accessible-text">
      <p>The Most Important Thing When Selecting Coffee is...</p>
    </div>
    <transition name="fade">
      <div :class="{ 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <ImportantThing class="important-thing" />
        </div>
        <div class="svg-wrapper">
          <ImportantThingMobile class="important-thing--mobile" />
        </div>
        <form class="buttons">
          <template v-for="(question, index) in questions">
            <div :key="index">
              <input type="radio" :id="question.id" name="mostImportant" :value="question.value" @click="formInteraction(question.value)" :checked="question.value === mostImportant">
              <label :for="question.id"><span v-html="question.label"></span></label>
            </div>
          </template>
        </form>
      </div>
    </transition>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/quiz_03-overlay--right@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <img :src="`${assetPath}lockup-overlays/quiz_03-overlay--bottom@2x.png`" alt="">
    </div>
  </div>
</template>

<script>
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'
import ImportantThing from '@/assets/important-thing.svg'
import ImportantThingMobile from '@/assets/important-thing--mobile.svg'

export default {
  name: 'QMostImportant',
  components: {
    ImportantThing,
    ImportantThingMobile
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      mostImportant: this.$store.state.quiz.mostImportant,
      questions: [
        {
          id: 'quality',
          value: 'quality',
          label: 'Quality'
        },
        {
          id: 'convenience',
          value: 'convenience',
          label: 'Convenience'
        },
        {
          id: 'cost',
          value: 'cost',
          label: 'Cost'
        }
      ]
    }
  },
  methods: {
    formInteraction(value) {
      this.mostImportant = value
      this.next('mostImportant', this.mostImportant)
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.important-thing {
  display: none;
  @include breakpoint(large) {
    display: block;
  }
}
.important-thing--mobile {
  display: block;
  @include breakpoint(large) {
    display: none;
  }
}

.question--question-three {
  // background-image: url($q3bgMobile);
  background-size: cover;
  width: 100%;
  .svg-wrapper {
    width: 85.866%;
    position: relative;
    top: -14vw;
  }
  .question-overlay--left {
    width: 13.95%;
  }
  .question-overlay--right {
    width: 23.6%;
  }
  .question-overlay--bottom {
    bottom: -8vw;
  }
  @include breakpoint(medium) {
    .question-overlay--bottom {
      bottom: -4vw;
    }
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 58%;
      top: -2vw;
      svg {
        height: 35vw; // for IE
      }
    }
    // background-image: url($q3bgDesktop);
  }
  .buttons {
    left: 0;
    right: 0;
    bottom: 18%; // proto
    width: 85%;
    margin: 0 auto;
    display: block;
    div {
      width: 100%;
      margin-bottom: -3px;
    }
    label {
      padding: 0.333em 1.5em;
    }
    @include breakpoint(large) {
      bottom: 15%;
      width: 57%;
      display: flex; // restore flex
      padding-left: 1.5%;
      label {
        padding: 0.5em 1.5em;
      }
      div {
        width: 33.333%;
        margin-right: -3px;
      }
    }
  }
}

</style>